module.exports = __webpack_public_path__ + "static/media/lynzi.b4a58fff.jpg";